var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-center",class:_vm.classes},[_c('p',[_c('span',{staticClass:"text-sm"},[_vm._v("v"+_vm._s(_vm.version))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }